import style from "./Footer.module.css";

function Footer() {
  return <div className={style.footer}> &nbsp;</div>;
}

export default Footer;
